import { useState } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { isInternalApp } from '../../utils/appsWithHiddenStatuses';
import { getOptions } from './utils/getOptions';
import { AuthorizationStatusPopover } from './AuthorizationStatusPopover';
import { useListingDetails } from '../../hooks/useListingDetails';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthorizationStatusView = ({
  accountStatusesList = [],
  alertStore,
  error,
  appId: propsAppId,
  listingDetails: propsListingDetails,
  loading = false,
  onAuthSucceeded,
  showInstalledStatus,
  showPopover = true,
  skipProductTypeCheck = false,
  tracker
}) => {
  var _accountStatusesList$;
  const {
    data: {
      productType
    },
    loading: productTypeLoading
  } = useListingDetails({
    appId: propsAppId,
    listingDetails: propsListingDetails,
    skip: skipProductTypeCheck
  });
  const authStatuses = accountStatusesList.filter(status => {
    return status.metadata.category === 'AUTHORIZATION';
  });
  const [popoverOpen, setPopoverOpen] = useState(undefined);
  const appId = propsAppId || ((_accountStatusesList$ = accountStatusesList[0]) === null || _accountStatusesList$ === void 0 ? void 0 : _accountStatusesList$.appId);
  const {
    popoverDisabled,
    popoverHeadingText,
    popoverMessage,
    content,
    ctaButton
  } = getOptions({
    accountStatusesList: authStatuses,
    alertStore,
    productType,
    loading: loading || productTypeLoading,
    setPopoverOpen,
    showInstalledStatus,
    onAuthSucceeded,
    tracker
  });
  if (isInternalApp(appId)) {
    return null;
  }
  if (error || !content) {
    return null;
  }
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    minBlockSize: "36px",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      showResult: false,
      grow: false,
      size: "xs",
      layout: "centered",
      minInlineSize: "100px"
    }) : /*#__PURE__*/_jsx(AuthorizationStatusPopover, {
      ctaButton: ctaButton,
      disabled: !showPopover || popoverDisabled,
      headingText: popoverHeadingText,
      message: popoverMessage,
      open: popoverOpen,
      children: content
    })
  });
};